<template lang="html">
  <div class="dev-component">
    <v-container>
      <v-row justify="center">
        <v-col class="d-flex" cols="12" sm="6">
          <v-select
          :disabled="!admin"
          v-model="database"
          :items="database_items"
          label="Adatbázis"
          outlined>
        </v-select>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-btn rounded color="primary" @click="saveConfig()">
          Mentés
          <v-icon right dark>save</v-icon>
        </v-btn>
      </v-row>
    </v-container>
    <v-snackbar v-model="save_config_snackbar" bottom>
      {{save_config_result}}
      <v-btn color="pink" text @click="save_config_snackbar = false">
        Bezár
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import {mapFields} from 'vuex-map-fields'

  export default {
    data () {
      return {
        save_config_snackbar: false,
        save_config_result: '',
        database_items: [
          { text: 'Éles adatbázis', value: 'true'},
          { text: 'Teszt adatbázis', value: 'false'},
        ],
        database: '',
        host: '',
      }
    },
    methods: {
      getConfig: async function() {
        this.exams = ''
        await this.gettoken()
        this.$http.post('/get_config', {
          token: this.token
        }).then((response) => {
          this.database = response.data['db']
          this.host = response.data['host']

        }, (error) => {
          this.error_text = error.data
        })
      },
      saveConfig: async function() {
        this.exams = ''
        await this.gettoken()
        this.$http.post('/save_config', {
          token: this.token,
          database: this.database,
        }).then((response) => {
          this.save_config_result = response.data
          this.save_config_snackbar = true
          location.reload();
        }, (error) => {
          this.error_text = error.data
        })
      },
    },
    mounted() {
      this.getConfig()
    },
    computed: {
    ...mapFields([
      'auth.loginuser',
      'auth.placeid',
      'auth.phoneNumber',
      'auth.fbuser',
      'auth.admin',
  ]),
  },
  }
</script>

<style lang="css">
</style>
